import React from 'react';
import { useSelector } from 'react-redux';

import {
	useIsBelowSmallOnly,
	useIsBelowXMediumOnly,
	useIsSmallAndAbove,
	useIsXMediumAndAbove,
} from '../hooks/mediaQueries';
import LargeListerLayout from './LargeListerLayout';
import SmallListerLayout from './SmallListerLayout';

const Container = () => {
	const isBelowSmallOnly = useIsBelowSmallOnly();
	const isSmallAndAbove = useIsSmallAndAbove();

	const isBelowXMediumOnly = useIsBelowXMediumOnly();
	const isXMediumAndAbove = useIsXMediumAndAbove();

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (CustomCategoriesEnabled) {
		return (
			<>
				{isBelowXMediumOnly && <SmallListerLayout />}
				{isXMediumAndAbove && <LargeListerLayout />}
			</>
		);
	}

	return (
		<>
			{isBelowSmallOnly && <SmallListerLayout />}
			{isSmallAndAbove && <LargeListerLayout />}
		</>
	);
};

export default Container;
